import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { NavigationSuggestion } from "./navigation-suggestion";

@Injectable({
  providedIn: "root"
})
export class NavigationSuggestionResolver {
  private router = inject(Router);

  isMobile = window.matchMedia("only screen and (max-width: 500px)").matches;

  public navigateToHint(navSuggestion: NavigationSuggestion) {
    if (!navSuggestion) {
      return;
    }

    switch (navSuggestion.location.toLowerCase()) {
      case "vcheqsubmission":
        {
          if (navSuggestion.param) {
            const vcheqUrl = ["activiteiten", "detail", navSuggestion.param];
            if (this.isMobile) {
              this.router.navigate(vcheqUrl, { queryParams: { reload: true } });
            } else {
              this.router.navigate(vcheqUrl);
            }
          } else {
            const planUrl = ["vitaliteit", "mijn-plan"];
            if (this.isMobile) {
              this.router.navigate(planUrl, { queryParams: { reload: true } });
            } else {
              this.router.navigate(planUrl);
            }
          }
        }
        break;
      case "nipedredirect":
        {
          this.router.navigate(["niped"]);
        }
        break;
    }
  }
}
